'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'redux-actions';
import actionTypes from '../constants/actionTypes';
import requestStatusType from '../constants/requestStatusTypes';
const {
  OWNERS_REQUESTED,
  OWNERS_SUCCEEDED,
  OWNERS_FAILED
} = actionTypes;
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
const initialState = ImmutableMap({
  owners: ImmutableMap(),
  ownerLabels: [],
  status: UNINITIALIZED
});
export default handleActions({
  [OWNERS_REQUESTED](state) {
    return state.set('status', PENDING);
  },
  [OWNERS_FAILED](state) {
    return state.set('status', FAILED);
  },
  [OWNERS_SUCCEEDED](state, {
    payload
  }) {
    return ImmutableMap(Object.assign({
      status: SUCCEEDED
    }, payload));
  }
}, initialState);